import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { PublicBannerCollectionItem } from '../../models/public-banner-collection-item';
import { PublicBannerDataSourceService } from '../../services/public-banner-data-source.service';
import { Carousel } from 'primeng/carousel';
import { BannerLocationType } from '../../../shared/enums/banner-location-type';
import { isNotNil } from '@web/utils';
import { PublicHomeBannerCarouselItemComponent } from '../../components/public-home-banner-carousel-item/public-home-banner-carousel-item.component';

@Component({
  selector: 'app-public-home-banner-carousel',
  imports: [CommonModule, Carousel, PublicHomeBannerCarouselItemComponent],
  templateUrl: './public-home-banner-carousel.component.html',
  styleUrl: './public-home-banner-carousel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicHomeBannerCarouselComponent {
  private readonly bannerDataSource = inject(PublicBannerDataSourceService);

  protected readonly banners$ = this.bannersSource();
  protected readonly isNotNil = isNotNil;

  protected isMoreThanOne(banners: PublicBannerCollectionItem[]): boolean {
    return banners.length > 1;
  }

  private bannersSource(): Observable<PublicBannerCollectionItem[]> {
    return this.bannerDataSource.fetchCollection({
      type: BannerLocationType.HomePage,
    });
  }
}
